// Template203: Bangkok - Aeropuertos (PageAeropuertos.jsx). borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const Template203 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content ?? "Aeropuertos";
	const intro = page?.texts?.[1]?.content;
	const bkkTitle = page?.texts?.[2]?.content ?? "Suvarnabhumi (BKK)";
	const bkkP = page?.texts?.[3]?.content;
	const bkkUl = page?.texts?.[4]?.content;
	const dmkTitle = page?.texts?.[5]?.content ?? "Don Mueang (DMK)";
	const dmkP = page?.texts?.[6]?.content;
	const dmkUl = page?.texts?.[7]?.content;
	const consejoText = page?.texts?.[8]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};
	const logoImage = getCanvasImageUrl("logo");
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: "0 0 6px 0",
		color: "#333",
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};
	const blockStyle = {
		backgroundColor: "#fff",
		borderRadius: "12px",
		padding: "12px 14px",
		display: "flex",
		alignItems: "flex-start",
		gap: "10px",
		border: "2px solid #d9e6de",
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>
			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "16px" }}>
					<Box component="p" sx={p}>
						{intro}
					</Box>
				</Box>
			)}
			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
				}}
			>
				<Box data-block-id="text-3" sx={blockStyle}>
					<Box sx={{ fontSize: 18 }}>✈️</Box>
					<Box sx={{ flex: 1 }}>
						<Box component="h3" sx={h3}>
							{bkkTitle}
						</Box>
						{bkkP && (
							<Box component="p" sx={{ ...p, marginBottom: 0.75 }}>
								{bkkP}
							</Box>
						)}
						{bkkUl && (
							<Box
								component="ul"
								sx={{ ...p, paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: bkkUl }}
							/>
						)}
					</Box>
				</Box>
				<Box data-block-id="text-4" sx={blockStyle}>
					<Box sx={{ fontSize: 18 }}>🛫</Box>
					<Box sx={{ flex: 1 }}>
						<Box component="h3" sx={h3}>
							{dmkTitle}
						</Box>
						{dmkP && (
							<Box component="p" sx={{ ...p, marginBottom: 0.75 }}>
								{dmkP}
							</Box>
						)}
						{dmkUl && (
							<Box
								component="ul"
								sx={{ ...p, paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: dmkUl }}
							/>
						)}
					</Box>
				</Box>
				{consejoText && (
					<Box
						data-block-id="text-5"
						sx={{
							backgroundColor: "#FFF3CD",
							border: "3px solid #E8A838",
							borderRadius: "12px",
							padding: "12px 14px",
							fontSize: 13,
							color: "#333",
						}}
					>
						<Box component="p" sx={{ ...p, margin: 0 }}>
							{consejoText}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template203.thumbnail = "/images/template-1.png";
export default Template203;
